/** Stage E — Global mount for the Opportunity Detail Drawer
 *
 * Any component on the page can open the drawer by dispatching:
 *     window.dispatchEvent(new CustomEvent("tm:open-drawer", { detail: { symbol: "NVDA" } }));
 *
 * This wrapper listens globally so we mount the drawer exactly once and don't
 * need to prop-drill open state through every page.
 */
import { useEffect, useState, useCallback } from "react";
import OpportunityDrawer from "./OpportunityDrawer";

export default function GlobalOpportunityDrawer() {
  const [symbol, setSymbol] = useState(null);
  const [initialTab, setInitialTab] = useState("overview");
  const open = Boolean(symbol);

  useEffect(() => {
    const onOpen = (e) => {
      const s = e?.detail?.symbol;
      const tab = e?.detail?.tab || "overview";
      if (!s) return;
      setSymbol(String(s).toUpperCase());
      setInitialTab(tab);
    };
    const onClose = () => setSymbol(null);
    window.addEventListener("tm:open-drawer", onOpen);
    window.addEventListener("tm:close-drawer", onClose);
    return () => {
      window.removeEventListener("tm:open-drawer", onOpen);
      window.removeEventListener("tm:close-drawer", onClose);
    };
  }, []);

  const close = useCallback(() => setSymbol(null), []);

  return <OpportunityDrawer open={open} symbol={symbol} initialTab={initialTab} onClose={close}/>;
}
